export default __webpack_public_path__ + "static/media/clock.d9b57ee9.png";